
import { useEffect, useState } from "react";
import { AuthMode, PluginConfig } from "../models/plugin-config";

type PluginConfigOverrides = {
    config?: PluginConfig;
    authMode?: AuthMode;
};

export function usePluginConfig(
    element: HTMLElement | null,
    overrides?: PluginConfigOverrides
): {
    config: PluginConfig | null;
    authMode: AuthMode;
    setAuthMode: React.Dispatch<React.SetStateAction<AuthMode>>;
} {
    const [config, setConfig] = useState<PluginConfig | null>(
        overrides?.config ?? null
    );
    const [authMode, setAuthMode] = useState<AuthMode>(
        overrides?.authMode ?? null
    );

    useEffect(() => {
        if (overrides?.config) {
            setConfig(overrides.config);
            if (overrides.authMode !== undefined) {
                setAuthMode(overrides.authMode);
            } else {
                setAuthMode("login");
            }
            return;
        }

        if (!element) return;

        const params =
            typeof window !== "undefined"
                ? new URLSearchParams(window.location.search)
                : new URLSearchParams();

        let chainId: string | null = element.dataset.chainid || null;
        let language: string | null = element.dataset.lang || null;
        let termsSourceCode: string | null = element.dataset.terms || null;
        if (!termsSourceCode) {
            termsSourceCode = params.get("terms");
        }
        setAuthMode(
            element.hasAttribute("data-registrationform") ||
                Boolean(params.get("registrationform"))
                ? "registration"
                : "login"
        );

        if (!chainId || !language) {
            chainId = chainId || params.get("chainid");
            language = language || params.get("lang");
        }
        if (chainId && language) {
            setConfig({
                chainId,
                language,
                termsSourceCode: termsSourceCode || undefined,
            });
        }
    }, [element, overrides?.config, overrides?.authMode]);

    return { config, authMode, setAuthMode };
}